(function () {
  const cap = window.Capacitor;
  if (!cap?.isNativePlatform?.() || cap.getPlatform?.() !== 'android') return;

  // Android's system "hide keyboard" arrow doesnt deselect the input, so we need to blur it manually
  window.addEventListener('keyboardDidHide', () => {
    const el = document.activeElement;
    if (!el) return;
    const isTextLike = el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el.isContentEditable;
    if (isTextLike) el.blur();
  });
})();
